export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comportamiento"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar información sobre el recopilador"])}
}